import { getItem, setItem } from './local-storage';
import uniqBy from 'lodash.uniqby';

const lsKey = 'quickFilters';

export interface IFilter {
  type: string;
  filter: string;
  display: string;
}

export function addFilter(filter: IFilter): void {
  // store filter.display untranslated, it will be translated in category link component
  if (filter.type !== 'trainerIds') {
    filter.display = filter.filter;
  }
  // The term 'program' is engrained throughout API's in iFIT and possibly unchangeable at this time
  if (filter.filter === 'program') {
    filter.display = 'series';
  }

  const withNewFilter = [filter, ...getFilters()];
  const onlyUniq = uniqBy(withNewFilter, 'filter');
  const limited = onlyUniq.slice(0, 10);
  setItem(lsKey, limited);
}

export function getFilters(): IFilter[] {
  return getItem(lsKey) || [];
}
